import Autocomplete from '@mui/material/Autocomplete';
import TextField from "@mui/material/TextField";
import { useMemo, useState } from "react";
import { Box } from "@mui/material";
import { TTimeZoneInput } from "./helper";
import { getLabelFromTimezone, getTimezoneFromLabel, getTimezoneLabels } from "../../../pages/project-calendar/helper";

export default function TimeZoneInput({ timeZone, handleSetTimeZone, BoxStyle, inputStyle }: TTimeZoneInput) {

  const [timeZoneLocal, setTimeZoneLocal] = useState<string>(timeZone);

  const timeZonesOptions = useMemo(() => {
    return getTimezoneLabels();
  }, []);

  const handleChange = (event: any, data: string) => {
    const selectedTimeZone = getTimezoneFromLabel(data);
    setTimeZoneLocal(selectedTimeZone);
    handleSetTimeZone(selectedTimeZone);
  };

  return (
    <Box sx={BoxStyle}>
      <Autocomplete
        sx={{ backgroundColor: "white", minWidth: "200px", ...inputStyle }}
        size="small"
        fullWidth
        onChange={handleChange}
        value={getLabelFromTimezone(timeZoneLocal)}
        options={timeZonesOptions}
        disableClearable
        renderInput={(params: any) => (
          <TextField {...params} label="Timezone" placeholder="Select Your TimeZone" />
        )}
      />
    </Box>
  );
}
